import type { GameOutcome } from '@sportninja/common/features/profile/stats/types'

import type { StatusTone } from 'src/components/ts-components/StatusChip'

export const TEAM_PLACEHOLDER =
  '/images/generic_placeholders/placeholder_team.png'

/** Result badge tone per outcome; a tie or unknown result reads neutral. */
export const RESULT_TONES: Record<GameOutcome, StatusTone> = {
  W: 'ok',
  L: 'error',
  T: 'muted',
}

export const NEUTRAL_RESULT_TONE: StatusTone = 'muted'

/**
 * Season table row and header heights (px), matching Schedule's `DetailsGrid`
 * and the operations grids so every ag-grid table reads the same.
 */
export const SEASON_GRID_ROW_HEIGHT = 48
export const SEASON_GRID_HEADER_HEIGHT = 44
